import { SxProps, Theme } from '@mui/material';

/**
 * 管理画面共通スタイル定義
 * すべての admin ページで統一されたデザインを適用するための設定ファイル
 */
export const adminStyles = {
  // ページコンテナ（デフォルト — maxWidth="lg" のフォーム・詳細ページ用）
  pageContainer: {
    py: { xs: 2, md: 4 },
  } as SxProps<Theme>,

  // フル幅ページコンテナ（テーブルを含むリスト系ページ用）
  // Container maxWidth={false} と組み合わせて使用
  fullWidthPageContainer: {
    py: { xs: 1, md: 4 },
    px: { xs: 1, md: 4 },
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  } as SxProps<Theme>,

  // ページヘッダー（タイトル + アクションボタン）
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'center' },
    mb: { xs: 2, md: 4 },
    gap: { xs: 1, md: 0 },
  } as SxProps<Theme>,

  // ページタイトル
  pageTitle: {
    fontWeight: 600,
    fontSize: { xs: '1.25rem', md: '2.125rem' },
  } as SxProps<Theme>,

  // 検索・フィルターエリア
  filterPaper: {
    p: { xs: 2, md: 3 },
    mb: { xs: 2, md: 3 },
    borderRadius: '12px',
  } as SxProps<Theme>,

  // テーブルエリア（モバイル: カード間背景透明化）
  tablePaper: {
    borderRadius: { xs: 0, md: '12px' },
    overflow: 'hidden',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: { xs: 'transparent', md: 'background.paper' },
    boxShadow: { xs: 'none', md: 1 },
  } as SxProps<Theme>,

  // コンテンツペーパー（詳細ページ、フォームなど）
  contentPaper: {
    p: { xs: 2, md: 4 },
    borderRadius: '12px',
  } as SxProps<Theme>,

  // テーブルヘッダー行
  tableHeaderRow: {
    bgcolor: '#f8f9fa',
  } as SxProps<Theme>,

  // テーブルヘッダーセル
  tableHeaderCell: {
    fontWeight: 600,
  } as SxProps<Theme>,

  // テーブル行（ホバー効果付き）
  tableRow: {
    '&:hover': { bgcolor: '#f8f9fa' },
    cursor: 'pointer',
  } as SxProps<Theme>,

  // アクションボタン（編集、削除など）
  actionButton: {
    borderRadius: '8px',
  } as SxProps<Theme>,

  // 検索ボタン
  searchButton: {
    borderRadius: '8px',
    minWidth: '80px',
  } as SxProps<Theme>,

  // 検索入力フィールドの高さ
  searchInputHeight: 40,

  // セクションタイトル（詳細ページ内）
  sectionTitle: {
    fontWeight: 600,
    mb: 2,
  } as SxProps<Theme>,
};
